<template>
  <v-form ref="invForm">
    <v-text-field
      v-model="Nombre"
      :rules="rules.Nombre"
      label="Nombre del recurso de inventario"
    >
    </v-text-field>
    <div class="text-right">
      <v-btn large @click="$emit('toggle', false)">Cancelar</v-btn>
      <v-btn style="margin-left: 6px" color="success" large @click="checkForm"
        >Guardar</v-btn
      >
    </div>
  </v-form>
</template>
<script>
export default {
  name: "invResForm",
  components: {},
  props: ["edit", "dataEdit"],
  data() {
    return {
      rules: {
        Nombre: [(value) => !!value || "El Nombre es obligatorio"],
      },
      Nombre: "",
      loader: true,
      modProshop: false,
      modClubPlaya: false,
      modRestaurante: false,
      errors: {},
      Id: "",
    };
  },
  methods: {
    checkForm: function (e) {
      if (this.$refs.invForm.validate()) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }
        this.$emit("successData", this.$data, doAction);
      }
    },
  },
  computed: {},
  watch: {},
  beforeMount: function () {},
  mounted() {
    this.loader = false;
    if (this.edit) {
      this.Id = this.dataEdit.id;
      this.Nombre = this.dataEdit.Nombre;
      this.modProshop = this.dataEdit.Departamentos
        ? this.dataEdit.Departamentos.ProShop
          ? this.dataEdit.Departamentos.ProShop
          : false
        : false;
      this.modClubPlaya = this.dataEdit.Departamentos
        ? this.dataEdit.Departamentos.ClubPlaya
          ? this.dataEdit.Departamentos.ClubPlaya
          : false
        : false;
      this.modRestaurante = this.dataEdit.Departamentos
        ? this.dataEdit.Departamentos.Restaurante
          ? this.dataEdit.Departamentos.Restaurante
          : false
        : false;
    }
  },
};
</script>
